// frontend/src/pages/SocialMedia.js

import React from 'react';

const SocialMedia = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-heading text-primary mb-4">Soziale Medien</h1>
      <ul className="list-disc list-inside space-y-2">
        <li>
          <a
            href="https://instagram.com/entecity.ch"
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 underline"
          >
            Instagram.com/entecity.ch
          </a>
        </li>
        <li>
          <a
            href="https://facebook.com/entecity.ch"
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 underline"
          >
            Facebook.com/entecity.ch
          </a>
        </li>
        <li>
          <a
            href="https://tiktok.com/@entecity"
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 underline"
          >
            tiktok.com/@entecity
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialMedia;
